import React, {useState} from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoggedIn } from '../../../../features/account/account.slice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';


const EditPasswordForm = ({closeModal, setServerMessage, userEmail, refreshData, refreshCookies}) => {

  const [currentPassword, setCurrentPassword] = useState(""); // State to store the current password
  const [showCurrentPassword, setShowCurrentPassword] = useState(false); // State to toggle password visibility
  const [newPassword, setNewPassword] = useState(""); // State to store the new password
  const [showNewPassword, setShowNewPassword] = useState(false); // State to toggle password visibility
  const [confirmNewPassword, setConfirmNewPassword] = useState(""); // State to store the confirmed new password
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false); // State to toggle password visibility
  const [processing, setProcessing] = useState(false); // State to indicate processing status

  const apiUrl = process.env.REACT_APP_API_BASE_URL; // Base URL for API calls

  const dispatch = useDispatch();

  const changePassword = async () => {
    const response = await fetch(`${apiUrl}/user/change-password`, {
      method: 'PUT', // Use PUT method for changing password
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        currentPassword: currentPassword, // Current password entered by the user
        newPassword: newPassword,
      }),
    });

    if (response.status === 401) {
      // Unauthorized, possibly session expired
      dispatch(setIsLoggedIn(false)); // Redux update will clear user data and redirect to login
      return;
    };

    const data = await response.json(); // Parse the response data

    if(data.success === true) {
      setServerMessage(data); // Set success message in server message state
    } else {
      setServerMessage(data); // Set error message in server message state
    }
  };

  const validatePassword = () => {
    //logic to validate the password
    if (currentPassword === '') {
      setServerMessage({success: false, message: 'Please enter your current password'});
      return false;
    }
    if (newPassword === '') {
      setServerMessage({success: false, message: 'Please enter a new password'});
      return false;
    }
    if (newPassword.length < 8) {
      setServerMessage({success: false, message: 'Password must be at least 8 characters long'});
      return false;
    }
    if (newPassword.length > 20) {
      setServerMessage({success: false, message: 'Password must be at most 20 characters long'});
      return false;
    }
    if (!/[a-z]/.test(newPassword)) {
      setServerMessage({success: false, message: 'Password must contain at least one lowercase letter'});
      return false;
    }
    if (!/[A-Z]/.test(newPassword)) {
      setServerMessage({success: false, message: 'Password must contain at least one uppercase letter'});
      return false;
    }
    if (!/[0-9]/.test(newPassword)) {
      setServerMessage({success: false, message: 'Password must contain at least one number'});
      return false;
    }
    if (!/[^a-zA-Z0-9]/.test(newPassword)) {
      setServerMessage({success: false, message: 'Password must contain at least one special character'});
      return false;
    }
    if (newPassword !== confirmNewPassword) {
      setServerMessage({success: false, message: 'Passwords do not match'});
      return false;
    }
    // Current password cannot be the same or similar as new password
    if (currentPassword === newPassword) {
      setServerMessage({success: false, message: 'New password cannot be the same as current password'});
      return false;
    }
    if (currentPassword.toLowerCase() === newPassword.toLowerCase()) {
      setServerMessage({success: false, message: 'New password cannot be similar to current password'});
      return false;
    }
    if (currentPassword.includes(newPassword) || newPassword.includes(currentPassword)) {
      setServerMessage({success: false, message: 'New password cannot be similar to current password'});
      return false;
    }

    return true; // Return true if all validations pass
  };

  const handleSubmit = async () => {
    // Function to handle the password change logic
    // You can add your API call or any other logic here
    setProcessing(true);
    if (validatePassword() === false) {
      setProcessing(false);
      return; // If validation fails, set the server message and return
    }
    await changePassword(); // Call the function to change the password
    //reset the password input fields
    setCurrentPassword(''); // Reset current password field
    setNewPassword(''); // Reset new password field
    setConfirmNewPassword(''); // Reset confirm new password field
    closeModal(); // Close the modal after submission
    setProcessing(false);
  }

  return (
    <div className=''>
      <h4 className='ms-1 mb-3'>Change Password</h4>
      <div style={{ position: "relative", marginBottom: "20px" }}>
          <input
              className="custom-input rounded"
              type={showCurrentPassword ? "text" : "password"}
              placeholder="Current password"
              onChange={(e) => setCurrentPassword(e.target.value)} // Update state with the current password
              onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
              onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
              style={{
                  height: "45px",
                  backgroundColor: "#171A29",
                  width: "100%", // Ensure the input takes the full width of the container
                  paddingRight: "40px", // Add padding to make space for the icon
                  border: "1px solid #3C3E4C",
                  color: "white",
              }}
          />
          <FontAwesomeIcon
              icon={showCurrentPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
              onClick={() => setShowCurrentPassword(!showCurrentPassword)} // Toggle password visibility
              style={{
                  position: "absolute",
                  right: "10px", // Position the icon 10px from the right edge of the input
                  top: "50%", // Center the icon vertically
                  transform: "translateY(-50%)", // Adjust for vertical centering
                  cursor: "pointer",
                  color: "#AEAFBA",
                  width: "20px",
                  height: "20px",
              }}
          />
      </div>
      <div style={{ position: "relative", marginBottom: "20px" }}>
          <input
              className="custom-input rounded"
              type={showNewPassword ? "text" : "password"}
              placeholder="New password"
              onChange={(e) => setNewPassword(e.target.value)} // Update state with the new password
              onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
              onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
              style={{
                  height: "45px",
                  backgroundColor: "#171A29",
                  width: "100%", // Ensure the input takes the full width of the container
                  paddingRight: "40px", // Add padding to make space for the icon
                  border: "1px solid #3C3E4C",
                  color: "white",
              }}
          />
          <FontAwesomeIcon
              icon={showNewPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
              onClick={() => setShowNewPassword(!showNewPassword)} // Toggle password visibility
              style={{
                  position: "absolute",
                  right: "10px", // Position the icon 10px from the right edge of the input
                  top: "50%", // Center the icon vertically
                  transform: "translateY(-50%)", // Adjust for vertical centering
                  cursor: "pointer",
                  color: "#AEAFBA",
                  width: "20px",
                  height: "20px",
              }}
          />
      </div>
      <div style={{ position: "relative", marginBottom: "20px" }}>
          <input
              className="custom-input rounded"
              type={showConfirmNewPassword ? "text" : "password"}
              placeholder="Confirm new password"
              onChange={(e) => setConfirmNewPassword(e.target.value)} // Update state with the new password
              onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
              onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
              style={{
                  height: "45px",
                  backgroundColor: "#171A29",
                  width: "100%", // Ensure the input takes the full width of the container
                  paddingRight: "40px", // Add padding to make space for the icon
                  border: "1px solid #3C3E4C",
                  color: "white",
              }}
          />
          <FontAwesomeIcon
              icon={showConfirmNewPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
              onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)} // Toggle password visibility
              style={{
                  position: "absolute",
                  right: "10px", // Position the icon 10px from the right edge of the input
                  top: "50%", // Center the icon vertically
                  transform: "translateY(-50%)", // Adjust for vertical centering
                  cursor: "pointer",
                  color: "#AEAFBA",
                  width: "20px",
                  height: "20px",
              }}
          />
      </div>
      <div className='d-flex justify-content-center align-items-center mt-4'>
        <button 
          className='rounded w-100' style={{ backgroundColor: '#FFCC19', height: "45px", fontWeight: 600 }}
          disabled={processing}
          onClick={() => {
            handleSubmit(); // Call the submit handler
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  )
}

export default EditPasswordForm